/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Legacy_Controls_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Timeline controls" |
*
* @param {Timeline_Legacy_Controls_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_legacy_controls_aria_label = /** @type {((inputs?: Timeline_Legacy_Controls_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Legacy_Controls_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Controles de la chronologie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitleistensteuerung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controlli della cronologia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Элементы управления временной шкалой")
	if (locale === "es") return /** @type {LocalizedString} */ ("Controles de la línea de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间线控件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムラインコントロール")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समयरेखा नियंत्रण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Controles da linha do tempo")
	return /** @type {LocalizedString} */ ("Timeline controls")
});